import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import KnowledgeBaseLayer from '../components/KnowledgeBaseLayer'

function KnowledgeBasePage() {
  return (
    <>
    {/* Master layout */}
    <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Knowledge Base"/>

        {/* Knowledge base layer */}
        <KnowledgeBaseLayer/>
    </MasterLayout>
    </>
  )
}

export default KnowledgeBasePage